// extracted by mini-css-extract-plugin
module.exports = {"container":"MiscInfo_container__1yd0s","item":"MiscInfo_item__2Mrte"};